var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popup',{attrs:{"visible":_vm.visible,"mask-click":_vm.maskClick},on:{"onMaskClick":_vm.maskClickHandle}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"containter"},[_vm._t("default")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }